var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 357,
    viewBox: "0 0 394 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.0188 351.941C95.9467 351.676 95.293 350.591 95.5587 349.519L99.8896 332.048C100.155 330.975 101.24 330.322 102.312 330.588C103.384 330.853 104.038 331.938 103.772 333.01L99.9225 348.54L115.452 352.39C116.525 352.655 117.178 353.74 116.912 354.812C116.647 355.884 115.562 356.538 114.49 356.272L97.0188 351.941ZM392.481 170.559C393.553 170.825 394.207 171.909 393.941 172.981L389.61 190.452C389.345 191.525 388.26 192.178 387.188 191.912C386.116 191.647 385.462 190.562 385.728 189.49L389.578 173.96L374.048 170.11C372.975 169.845 372.322 168.76 372.588 167.688C372.853 166.616 373.938 165.962 375.01 166.228L392.481 170.559ZM96.4676 348.287L390.968 170.787L393.032 174.213L98.5324 351.713L96.4676 348.287Z",
    fill: "#2D9DC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175 275L160.5 267.5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181 233L191 239",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 166L172 162V221L165 225.5V166Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186 155.5L193 151.5V210.5L186 215V155.5Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205 144.5L212 140.5V199.5L205 204V144.5Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224 133.5L231 129.5V188.5L224 193V133.5Z",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243 121.5L250 117.5V176.5L243 181V121.5Z",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M262 110.5L269 106.5V165.5L262 170V110.5Z",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M281 100.5L288 96.5V155.5L281 160V100.5Z",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M359 54.5L366 50.5V109.5L359 114V54.5Z",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M338 66.5L345 62.5V121.5L338 126V66.5Z",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M322 75.5L329 71.5V130.5L322 135V75.5Z",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M301 89.5L308 85.5V144.5L301 149V89.5Z",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 308L55 301V311L66.5 318V308Z",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 280.5L5 273.5V283.5L16.5 290.5V280.5Z",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86 244.5L70.5 289V332.5",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90 126.5L305 1L374.5 41.5M90 126.5L161.5 165M90 126.5V193.5M374.5 41.5L161.5 165M374.5 41.5V109.5M161.5 165V232.5M90 193.5L161.5 232.5M90 193.5V198L161.5 237V244.5L300 165V189.5M161.5 232.5L374.5 109.5M374.5 109.5V147.5L369.5 151M127 222L58 182.5L16 205.5M127 222L86 244.5L16 205.5M127 222V297.5L115.5 304.5C116 287.5 106.5 285 97.5 289.5C87 297 82.5 308.5 86 321L71 332.5L1 291.5V249.5L16 205.5M19.5 215L8 249.5L65.5 284L77.5 248L19.5 215ZM120 232.5L90 249.5L77.5 286.5L120 261V232.5Z",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 240L128 254V284.5L160 267V247L149.5 240Z",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.783 262.208C192.511 267.155 189.155 271.011 185.588 273.257C182.017 275.506 178.297 276.11 175.222 274.698C172.147 273.286 170.18 270.07 169.558 265.896C168.937 261.728 169.675 256.669 171.946 251.722C174.218 246.775 177.575 242.918 181.141 240.673C184.712 238.424 188.432 237.82 191.507 239.232C194.582 240.644 196.549 243.859 197.171 248.033C197.792 252.202 197.055 257.261 194.783 262.208Z",
    stroke: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.293 259.751C187.339 261.827 185.936 263.432 184.462 264.361C182.983 265.292 181.494 265.511 180.294 264.96C179.093 264.408 178.289 263.136 178.032 261.408C177.775 259.685 178.078 257.574 179.031 255.498C179.984 253.422 181.388 251.817 182.862 250.889C184.341 249.957 185.83 249.738 187.03 250.289C188.231 250.841 189.035 252.113 189.292 253.841C189.549 255.564 189.246 257.675 188.293 259.751Z",
    stroke: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.642 312.382C109.371 317.329 106.014 321.186 102.447 323.431C98.8764 325.68 95.156 326.284 92.0812 324.872C89.0063 323.46 87.0396 320.245 86.4178 316.071C85.7969 311.902 86.534 306.843 88.8056 301.896C91.0772 296.949 94.434 293.093 98.0004 290.847C101.571 288.598 105.292 287.994 108.367 289.406C111.442 290.818 113.408 294.033 114.03 298.208C114.651 302.376 113.914 307.435 111.642 312.382Z",
    stroke: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.152 309.925C104.199 312.001 102.795 313.607 101.321 314.535C99.8427 315.466 98.3536 315.685 97.1531 315.134C95.9526 314.583 95.1484 313.31 94.891 311.582C94.6343 309.859 94.9375 307.748 95.8907 305.672C96.8438 303.597 98.2472 301.991 99.7213 301.063C101.2 300.132 102.689 299.912 103.89 300.464C105.09 301.015 105.894 302.287 106.152 304.016C106.408 305.739 106.105 307.849 105.152 309.925Z",
    stroke: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M333.642 182.382C331.371 187.329 328.014 191.186 324.447 193.431C320.876 195.68 317.156 196.284 314.081 194.872C311.006 193.46 309.04 190.245 308.418 186.071C307.797 181.902 308.534 176.843 310.806 171.896C313.077 166.949 316.434 163.093 320 160.847C323.571 158.598 327.292 157.994 330.367 159.406C333.442 160.818 335.408 164.033 336.03 168.208C336.651 172.376 335.914 177.435 333.642 182.382Z",
    stroke: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M327.152 179.925C326.199 182.001 324.795 183.607 323.321 184.535C321.843 185.466 320.354 185.685 319.153 185.134C317.953 184.583 317.148 183.31 316.891 181.582C316.634 179.859 316.938 177.748 317.891 175.672C318.844 173.597 320.247 171.991 321.721 171.063C323.2 170.132 324.689 169.912 325.89 170.464C327.09 171.015 327.894 172.287 328.152 174.016C328.408 175.739 328.105 177.849 327.152 179.925Z",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M365.642 164.382C363.371 169.329 360.014 173.186 356.447 175.431C352.876 177.68 349.156 178.284 346.081 176.872C343.006 175.46 341.04 172.245 340.418 168.071C339.797 163.902 340.534 158.843 342.806 153.896C345.077 148.949 348.434 145.093 352 142.847C355.571 140.598 359.292 139.994 362.367 141.406C365.442 142.818 367.408 146.033 368.03 150.208C368.651 154.376 367.914 159.435 365.642 164.382Z",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M359.152 161.925C358.199 164.001 356.795 165.607 355.321 166.535C353.843 167.466 352.354 167.685 351.153 167.134C349.953 166.583 349.148 165.31 348.891 163.582C348.634 161.859 348.938 159.748 349.891 157.672C350.844 155.597 352.247 153.991 353.721 153.063C355.2 152.132 356.689 151.912 357.89 152.464C359.09 153.015 359.894 154.287 360.152 156.016C360.408 157.739 360.105 159.849 359.152 161.925Z",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M219.293 240.751C218.339 242.827 216.936 244.432 215.462 245.361C213.983 246.292 212.494 246.511 211.294 245.96C210.093 245.408 209.289 244.136 209.032 242.408C208.775 240.685 209.078 238.574 210.031 236.498C210.984 234.422 212.388 232.817 213.862 231.889C215.341 230.957 216.83 230.738 218.03 231.289C219.231 231.841 220.035 233.113 220.292 234.841C220.549 236.564 220.246 238.675 219.293 240.751Z",
    stroke: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M225.642 243.382C223.371 248.329 220.014 252.186 216.447 254.431C212.876 256.68 209.156 257.284 206.081 255.872C203.006 254.46 201.04 251.245 200.418 247.071C199.797 242.902 200.534 237.843 202.806 232.896C205.077 227.949 208.434 224.093 212 221.847C215.571 219.598 219.292 218.994 222.367 220.406C225.442 221.818 227.408 225.033 228.03 229.208C228.651 233.376 227.914 238.435 225.642 243.382Z",
    stroke: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M192 239.5C192.275 232.887 193.291 229.568 197 224.5",
    stroke: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49 297L21 280.5V284L49 300.5V297Z",
    stroke: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49 303L21 286.5V290L49 306.5V303Z",
    stroke: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49 309L21 292.5V296L49 312.5V309Z",
    stroke: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M300 189.5L278.5 177.5",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 206.797,
    y1: 256.957,
    x2: 197.797,
    y2: 252.957,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 223.829,
    y1: 219.97,
    x2: 212.829,
    y2: 215.97,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 308.265,
    y1: 183.924,
    x2: 300.265,
    y2: 188.924,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 340.3,
    y1: 167.9,
    x2: 336.3,
    y2: 170.9,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleLength);
export default __webpack_public_path__ + "static/media/vehicle-length.63a12d09ce8eac9e491af3c236e6914f.svg";
export { ForwardRef as ReactComponent };